
export default function StreamerRewards() {
  const rewards = [
    {
      icon: 'ri-trophy-fill',
      title: 'Weekly PSU Leaderboard',
      description: 'Compete for top spots and gain recognition in the community',
      badge: 'WEEKLY',
      color: 'purple'
    },
    {
      icon: 'ri-gift-fill',
      title: 'Bonus Rewards + Merch',
      description: 'Top performers receive exclusive merchandise and bonus rewards',
      badge: 'EXCLUSIVE',
      color: 'emerald'
    },
    {
      icon: 'ri-vip-crown-fill',
      title: 'VIP Community Access',
      description: 'Exclusive Discord channels and early access to new features',
      badge: 'VIP',
      color: 'purple'
    }
  ];

  return (
    <section className="py-24 px-6 relative">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-5xl md:text-6xl font-black text-transparent bg-clip-text bg-gradient-to-r from-emerald-400 to-purple-400 mb-8">
            Streamer Rewards
          </h2>
          <div className="w-24 h-1 bg-gradient-to-r from-emerald-400 to-purple-400 mx-auto mb-8"></div>
          <p className="text-xl text-gray-200 max-w-3xl mx-auto">
            We believe in rewarding our community. Here's what you can earn as a PSU streamer.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          {rewards.map((reward, index) => (
            <div key={index} className="group relative">
              <div className="bg-gradient-to-br from-slate-800/50 to-slate-900/50 p-8 rounded-3xl border border-gray-700/50 hover:border-emerald-500/30 transition-all duration-500 hover:transform hover:scale-105 h-full relative overflow-hidden">
                {/* Badge */}
                <div className={`absolute top-4 right-4 px-3 py-1 rounded-full text-xs font-bold ${reward.color === 'emerald' ? 'bg-emerald-500/20 text-emerald-400 border border-emerald-500/30' : 'bg-purple-500/20 text-purple-400 border border-purple-500/30'}`}>
                  {reward.badge}
                </div>

                {/* Icon */}
                <div className={`w-20 h-20 bg-gradient-to-br ${reward.color === 'emerald' ? 'from-emerald-500/20 to-emerald-600/20' : 'from-purple-500/20 to-purple-600/20'} rounded-3xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300`}>
                  <i className={`${reward.icon} text-3xl ${reward.color === 'emerald' ? 'text-emerald-400' : 'text-purple-400'}`}></i>
                </div>

                {/* Content */}
                <h3 className="text-2xl font-bold text-white mb-4">{reward.title}</h3>
                <p className="text-gray-300 leading-relaxed mb-6">{reward.description}</p>

                {/* Action */}
                <div className="flex items-center text-emerald-400 font-medium group-hover:text-emerald-300 transition-colors">
                  <span>Learn More</span>
                  <i className="ri-arrow-right-line ml-2 group-hover:translate-x-1 transition-transform"></i>
                </div>

                {/* Hover effect */}
                <div className="absolute inset-0 bg-gradient-to-br from-emerald-500/5 to-purple-500/5 opacity-0 group-hover:opacity-100 transition-opacity duration-500 rounded-3xl"></div>
              </div>
            </div>
          ))}
        </div>

        {/* Additional rewards section */}
        <div className="mt-16 bg-gradient-to-r from-slate-800/30 to-slate-900/30 rounded-3xl p-12 border border-gray-700/30">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
            <div>
              <h3 className="text-3xl font-bold text-white mb-6">Unlock More Rewards</h3>
              <div className="space-y-4">
                <div className="flex items-center">
                  <div className="w-8 h-8 bg-emerald-500/20 rounded-full flex items-center justify-center mr-4">
                    <i className="ri-check-line text-emerald-400"></i>
                  </div>
                  <span className="text-gray-200">Monthly bonus distributions</span>
                </div>
                <div className="flex items-center">
                  <div className="w-8 h-8 bg-purple-500/20 rounded-full flex items-center justify-center mr-4">
                    <i className="ri-check-line text-purple-400"></i>
                  </div>
                  <span className="text-gray-200">Exclusive PSU merchandise</span>
                </div>
                <div className="flex items-center">
                  <div className="w-8 h-8 bg-emerald-500/20 rounded-full flex items-center justify-center mr-4">
                    <i className="ri-check-line text-emerald-400"></i>
                  </div>
                  <span className="text-gray-200">VIP Discord access</span>
                </div>
                <div className="flex items-center">
                  <div className="w-8 h-8 bg-purple-500/20 rounded-full flex items-center justify-center mr-4">
                    <i className="ri-check-line text-purple-400"></i>
                  </div>
                  <span className="text-gray-200">Early access to new features</span>
                </div>
              </div>
            </div>
            
            <div className="relative">
              <img
                src="https://public.readdy.ai/ai/img_res/283bfc15bfea0d0bd036e05fcd3740ca.jpg"
                alt="PSU Rewards"
                className="w-full rounded-2xl shadow-2xl object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-slate-900/50 to-transparent rounded-2xl"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
